export function removeInstantLoader() {
  const instantLoader = document.getElementById('instant-loader');

  if (document.body.contains(instantLoader)) {
    document.body.removeChild(instantLoader);
  }
}
